var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$$IsAdmin)?_c('div',{staticClass:"shop-info-selector"},[_c('en-shop-picker',{attrs:{"show":_vm.show_shop_picker,"buyer-domain":_vm.$$Domain['buyer_pc'],"limit":1,"before-close":_vm.checkShopInfo},on:{"update:show":function($event){_vm.show_shop_picker=$event},"confirm":_vm.handleShopPickerConfirm}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }